import { runDemo } from "../shared/demoRunner";
import { createDefaultRenderingPipelineScene } from "./scene";

runDemo({ createScene: createDefaultRenderingPipelineScene });
